import { render, staticRenderFns } from "./ViewRoles.vue?vue&type=template&id=57483478&"
import script from "./ViewRoles.vue?vue&type=script&lang=js&"
export * from "./ViewRoles.vue?vue&type=script&lang=js&"
import style0 from "./ViewRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports